// Module
var code = "<template><div class=\"partial-activity-assignment\" if.bind=\"!isUpcomingAssignment\"><p if.bind=\"assignment.isCurrentAssignment\">${'awaiting-payment-confirmation-on-credit-activity-message' & t}</p><p if.bind=\"assignment.isAccepted\">${'received-payment-confirmation-on-credit-activity-message' & t}</p></div></template>";
// Exports
module.exports = code;